import React, { useState } from "react";
import { Chevron } from "@speedoc/design-assets/build/icons/index";
import { slugToCountryPathname } from "../../utils/strings";
import { useMediaQuery } from "react-responsive";

export const CardItem = props => {
  const isMobile = useMediaQuery({ query: "(max-width: 768px)" });
  const { hide, card, expandItem } = props;

  return isMobile ? (
    <div className="card" onClick={expandItem}>
      <div className="headerContainer">
        <div className="catelogImage">
          <img src={card.imageCard.url} alt="pacakgeImage" />
        </div>
        <div className="header">{card.header}</div>
      </div>
      <div className="contentContainer">
        <div className="cardDescription">{card.description}</div>
        <div className={`icon ${hide ? "up" : ""}`}>
          <Chevron />
        </div>
      </div>
      <div className="claimableContainer">
        <div className="imageTitle">{card.imagetitle}</div>
        <div className="imageList">
          {card.images &&
            card.images.map((image, index) => <img key={image.url} src={image.url} alt={"clamableImage"} />)}
        </div>
      </div>
    </div>
  ) : (
    <div className="card" onClick={expandItem}>
      <div className="catelogImage">
        <img src={card.imageCard.url} alt="pacakgeImage" />
      </div>
      <div className="contentContainer">
        <div className="header">{card.header}</div>
        <div className="cardDescription">{card.description}</div>
      </div>
      <div className="claimableContainer">
        <div className="imageContainer">
          <div className="imageTitle">{card.imagetitle}</div>
          <div className="imageList">
            {card.images &&
              card.images.map((image, index) => <img key={image.url} src={image.url} alt={"clamableImage"} />)}
          </div>
        </div>
        <div className={`icon ${hide ? "up" : ""}`}>
          <Chevron />
        </div>
      </div>
    </div>
  );
};

export const OverviewSection = props => {
  const propsOverview = props.overview;

  return (
    <div className="overviewSection">
      <div className="overviewContainer">
        <div className="overview">{propsOverview.title || "Overview"}:</div>
        <div className="overviewContainer">
          <ul>
            {propsOverview.overviewList.map((overview, index) => (
              <li key={`overview_${index}`}>{overview}</li>
            ))}
          </ul>
        </div>
      </div>
      {propsOverview.note && (
        <>
          <div className="noteContainer">
            <div className="note">Note(s):</div>
            <div className="overviewNote">{propsOverview.note}</div>
          </div>
        </>
      )}
    </div>
  );
};

export const DetailSection = props => {
  const isMobile = useMediaQuery({ query: "(max-width: 768px)" });
  const detailList = props.detailSection.detailItems;
  const itemsBinding = [];

  let maxDetailLength = 0;
  detailList.forEach(item => {
    itemsBinding.push({ parent: "", text: item.title });
    if (item.details) {
      if (maxDetailLength < item.details.length) {
        maxDetailLength = item.details.length + 1;
      }
      item.details.forEach(detail => {
        itemsBinding.push({ parent: item.title, text: detail });
      });
    }
  });

  let itemPerColumn = Math.ceil(itemsBinding.length / 3);

  const buildDetailList = columnIndex => {
    const length = columnIndex + 1;
    const totalItem = maxDetailLength > itemPerColumn ? maxDetailLength : itemPerColumn;
    const items = itemsBinding.slice(columnIndex * totalItem, totalItem * length);
    return items.map((item, index) => (
      <>
        <div key={item.text} className={"detailItem"}>
          <div className="iconDot">
            <div className={`dot ${item.parent.length > 0 ? "dotChild" : ""}`} />
          </div>
          <div className={`detailTitle ${item.parent.length > 0 ? "detailChild" : ""}`}>{item.text}</div>
        </div>
      </>
    ));
  };

  const buildDetailListForMobile = () => {
    return itemsBinding.map((item, index) => (
      <>
        <div key={item.text} className={"detailItem"}>
          <div className="iconDot">
            <div className={`dot ${item.parent.length > 0 ? "dotChild" : ""}`} />
          </div>
          <div className={`detailTitle ${item.parent.length > 0 ? "detailChild" : ""}`}>{item.text}</div>
        </div>
      </>
    ));
  };

  return (
    <div className="detailSection">
      <div className="programmeDetails">{props.detailSection.title || "Programme Details"}:</div>
      <div className="detailContainer">
        {isMobile ? (
          <div>{buildDetailListForMobile()}</div>
        ) : (
          <>
            <div className="column1">{buildDetailList(0)}</div>
            <div className="column2">{buildDetailList(1)}</div>
            <div className="column3">{buildDetailList(2)}</div>
          </>
        )}
      </div>
    </div>
  );
};

export const Schedule = props => {
  const schedules = props.schedule;

  const timeLineMonth = item => {
    return item.timelinemonth && item.timelinemonth !== "0" ? item.timelinemonth : "";
  };

  return (
    <div className="scheduleSection">
      <div className="schedule">Schedule:</div>
      <div className="scheduleTimeline">
        {schedules &&
          schedules.map((item, index) => (
            <div key={`scheduleSection_${index}`} className="timelineContainer">
              <div className="timelineArea">
                <div className="timelineInfor">
                  <div className="timelineMonth">{timeLineMonth(item)}</div>
                  <div className="timelineVisit" style={{ marginTop: timeLineMonth(item).length === 0 ? 23 : 0 }}>
                    {item.visit}
                  </div>
                </div>
                <div className="timeline">
                  <div className="line" />
                  <div className="timelineDot" />
                </div>
              </div>

              <div className="timelineContent">
                {item.content.map(con => (
                  <div key={con} className="timelineItem">
                    {con}
                  </div>
                ))}
              </div>
            </div>
          ))}
      </div>
    </div>
  );
};

export const RichtextSection = props => {
  const content = props.content;
  return <div className="richText" dangerouslySetInnerHTML={{ __html: content }} />;
};

const PackageCatelog = ({ content }) => {
  const { subtitle, title, description, packageCatelogItems, linearGradient } = content;
  const [activeCardIndex, setActiveCardIndex] = useState(-1);
  const [showDetail, setShowDetail] = useState(false);

  const setActiveTab = index => {
    if (activeCardIndex === -1) {
      setShowDetail(!showDetail);
      setActiveCardIndex(index);
    } else if (activeCardIndex === index) {
      setShowDetail(!showDetail);
    } else {
      setShowDetail(false);
      setActiveCardIndex(index);
      setShowDetail(true);
    }
  };

  return (
    <div id="PackageCatelog">
      <div className="wrap" style={{ "--linear-bg-catalog": linearGradient || "#F6F6F6" }}>
        <div className="subtitle">{subtitle}</div>
        <div className="title">{title}</div>
        <div className="description">{description}</div>
        {packageCatelogItems &&
          packageCatelogItems.length > 0 &&
          packageCatelogItems.map((catelogItem, index) => (
            <div key={`PackageCatelog_${index}`} className="packageCatelogContainer">
              <CardItem
                key={`card_${index}`}
                expandItem={() => packageCatelogItems.length > 1 && setActiveTab(index)}
                card={catelogItem.card}
                hide={showDetail && activeCardIndex === index}
              />
              <div
                className={`catelogDetail ${
                  (showDetail && activeCardIndex === index) || packageCatelogItems.length === 1 ? "" : "hide"
                }`}>
                {catelogItem.overviewsection && (
                  <>
                    <div className="separate" />
                    <OverviewSection key={`OverviewSection_${index}`} overview={catelogItem.overviewsection} />
                  </>
                )}

                {catelogItem.detailviewsection && (
                  <>
                    <div className="separate" />
                    <DetailSection detailSection={catelogItem.detailviewsection} />
                  </>
                )}
                {catelogItem.schedulesection && catelogItem.schedulesection?.length > 0 && (
                  <>
                    <div className="separate" />
                    <Schedule key={`Schedule_${index}`} schedule={catelogItem.schedulesection} />
                  </>
                )}
                {catelogItem.richtextsection && catelogItem.richtextsection?.length > 0 && (
                  <>
                    <div className="separate" />
                    <RichtextSection content={catelogItem.richtextsection} />
                  </>
                )}
                <div className="inforButtonGroup">
                  {catelogItem.requestbutton && (
                    <div className="btn request">
                      <a href={slugToCountryPathname(catelogItem.requestbutton?.link)}>
                        <span>{catelogItem.requestbutton?.label}</span>
                      </a>
                    </div>
                  )}
                  {catelogItem.moreinforbutton && (
                    <div className="btn moreInfor">
                      <a href={slugToCountryPathname(catelogItem.moreinforbutton?.link)}>
                        {catelogItem.moreinforbutton?.label}
                      </a>
                    </div>
                  )}
                </div>
              </div>
            </div>
          ))}
      </div>
    </div>
  );
};

export default PackageCatelog;
